import { render, staticRenderFns } from "./volunteer-carousel.vue?vue&type=template&id=0b0bead2&scoped=true"
import script from "./volunteer-carousel.vue?vue&type=script&lang=js"
export * from "./volunteer-carousel.vue?vue&type=script&lang=js"
import style0 from "./volunteer-carousel.vue?vue&type=style&index=0&id=0b0bead2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0bead2",
  null
  
)

export default component.exports